import React from "react";

const summary = <p>A short comedy about a young student trying to get a free bus ride from an old curmudgeon of a bus driver. 2011</p>;

export default summary;